<template>
    <v-content padding=0>
      <v-container id="adminContainer" fluid pa-0>
        <router-view/>
      </v-container>
    </v-content>
</template>

<script>
import { components } from 'aws-amplify-vue'

export default {
  name: 'adminContent',
  components: {
    ...components
  },
  data () {
    return {}
  },
  methods: {}
}
</script>
<style>
  #adminContainer {
    /* margin-left: 300px; */
  }
</style>
